module.exports = __webpack_public_path__ + "static/media/instagram.d6cd23ba.svg";